import http from '@/http'

export function get(params) {
  return http.get('/cex', {
    loading: true,
    params
  })
}

export function money(id, data) {
  return http.post('/cex/money/' + id, data)
}

export function order(id, data) {
  return http.post('/cex/order/' + id, data)
}

export function query(data) {
  return http.post('/cex/query', data)
}